// extracted by mini-css-extract-plugin
export var chatHtmlText = "_ow-2";
export var chatLink = "_ow-0";
export var chatText = "_ow-1";